// Módulos
import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"

// Componentes
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { PswResetComponent } from "./psw-reset/psw-reset.component";

// Rutas para componentes NO logeado 
const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'registro', component: RegisterComponent },
    { path: 'usr_psw_set/:md5', component: PswResetComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],       // Menú raiz
    exports: [RouterModule]
})
export class AuthRoutingModule { }
